import * as React from 'react';

import { ActionsDropdown } from '@components/library/dropdown/index';
import { ActionDropdownItem } from '@components/library/dropdown_item/index';

interface AssetBoardActionsProps {
  closeDropdown: boolean;
  handleShowRemoveModal: () => void;
  updateCloseDropdown: () => void;
  handleShowRenameModal?: () => void;
  isBoardCard?: boolean;
}

// contains the trigger buttons and menus for the board overlay
const AssetBoardActions = ({
  closeDropdown,
  handleShowRemoveModal,
  handleShowRenameModal,
  isBoardCard,
  updateCloseDropdown,
}: AssetBoardActionsProps): JSX.Element => (
  <div className="asset-board-actions">
    <ActionsDropdown
      className="asset-card-actions"
      closeCallback={updateCloseDropdown}
      closeDropdown={closeDropdown}
      openOnClick={false}
      openOnHover
      userDevice={BFG?.currentUser?.device}
    >
      {!!isBoardCard && (
        <ActionDropdownItem
          icon="bff-edit"
          key="rename-asset-board"
          name="rename-asset-board"
          onChoose={handleShowRenameModal}
        >
          {bfTranslate("Rename")}
        </ActionDropdownItem>
      )}
      <ActionDropdownItem
        icon="bff-trash"
        isWarningItem
        key={isBoardCard ? "delete-asset-board" : "remove-asset-card"}
        name={isBoardCard ? "delete-asset-board" : "remove-asset-card"}
        onChoose={handleShowRemoveModal}
      >
        {isBoardCard ? bfTranslate("Delete") : bfTranslate("Remove")}
      </ActionDropdownItem>
    </ActionsDropdown>
  </div>
);

export default AssetBoardActions;
